// features/auth/pages/LoginPage.tsx

import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { LoginForm } from '../components/LoginForm';
import { useAuth } from '../hooks/useAuth';

import Layout from '../../../components/Modular/Layout';
import Section from '../../../components/Modular/Section';
import MicroUnit from '../../../components/Modular/MicroUnit';
import NanoUnit from '../../../components/Modular/NanoUnit';

interface LoginLocationState {
  from?: {
    pathname?: string;
  };
}

export default function LoginPage() {
  const { status } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state as LoginLocationState | null;

  const destination = state?.from?.pathname ?? '/';

  if (status === 'checking') {
    return null;
  }

  if (status === 'authenticated') {
    return <Navigate to={destination} replace />;
  }

  return (
    <Layout
      as="main"
      layout="grid"
      justifyItems="center"
      alignItems="center"
      background="brand-secondary"
      padding="lg"
    >
      <Section
        layout="flex"
        flexDirection="column"
        width="100"
        widthMax="448"
        gap="xsm"
        paddingLeft="xl"
        paddingRight="xl"
        paddingTop="xl"
        paddingBottom="xl"
        borderColor="subtle"
        borderRadius="lg"
        background="surface"
        boxShadow="panel"
        backdropFilter="blur"
      >
        <Section as="header" layout="flex" flexDirection="column" gap="xsm">
          <NanoUnit as="span" typography="eyebrow">
            Clockhead
          </NanoUnit>
          <MicroUnit as="h1" h1Typography="section-title" h1Color="text-light">
            Admin
          </MicroUnit>
        </Section>

        <LoginForm
          onSuccess={() => {
            navigate(destination, {
              replace: true,
            });
          }}
        />
      </Section>
    </Layout>
  );
}
